import React, { Component } from "react";
import { toast } from "react-toastify";
import { IoArrowBackOutline } from "react-icons/io5";
import { TfiLink } from "react-icons/tfi";
import { Modal, Button, Form } from "react-bootstrap";
import { Carousel } from "react-responsive-carousel";
import { getCookie, setCookie } from "../../function";
import taConnectLogo from "../../assets/taconnect/taconnectlogotsat.png";
import imgOne from "../../assets/taconnect/taImg1.png";
import imgTwo from "../../assets/taconnect/taImg2.png";
import imgThree from "../../assets/taconnect/taImg3.png";
import imgFour from "../../assets/taconnect/taImg4.png";
import imgFive from "../../assets/taconnect/taImg5.png";
import imgSix from "../../assets/taconnect/taImg6.png";
import "./connect-ta.css";
import apiError from "../../error";
import axios from "../../axios";
import Loader from "../loader/loader";
import "react-responsive-carousel/lib/styles/carousel.min.css";

export default class NewConnectTAModal extends Component {
  constructor(props) {
    super(props);
    this.isTAconnected = getCookie("isTAconnected");
    this.state = {
      currentSlide: 0,
      loading: false,
      showIntegrationModal: false,
      agreed: false,
      show: false,
      selectedImage: null,
    };
  }


  handleClose = () => {
    this.setState({ show: false, selectedImage: null });
  };

  handleSelect = (index) => {
    this.setState({ currentSlide: index });
  };

  handleOpen = (image) => {
    this.setState({ show: true, selectedImage: image });
  };

  handleTAconnection = () => {
    this.setState({ loading: true });

    const isTAconnected =
      this.isTAconnected === "true" || this.isTAconnected === true;

    axios
      .patch("/api/adminCentral/update-TAconnection-status", {
        connectionStatus: !isTAconnected,
      })
      .then((res) => {
        const { connectionStatus, message } = res.data;
        this.setState({ loading: false });
        toast.success(message);
        if (!connectionStatus) {
          setCookie("isTAconnected", false, 30000);
          setTimeout(() => {
            window.location.href = `${process.env.REACT_APP_API_URL}/dashboard`;
          }, 1500);
        } else {
          setCookie("isTASyncing", true, 30000);
          setTimeout(() => {
            window.location.href = `${process.env.REACT_APP_API_URL}/dashboard`;
          }, 1500);
        }
      })
      .catch((error) => {
        this.setState({ loading: false });
        apiError(error);
      });
  };

  IntegrationHandleShow = () => {
    this.setState({ showIntegrationModal: true });
  };

  IntegrationHandleClose = () => {
    this.setState({ showIntegrationModal: false, agreed: false });
  };

  handleAgreementChange = (e) => {
    this.setState({ agreed: e.target.checked });
  };

  render() {
    const images = [imgOne, imgTwo, imgThree, imgFour, imgFive, imgSix];
    const { currentSlide, loading, showIntegrationModal, agreed , selectedImage, } = this.state;


    return (
      <>
        {/* Main Integration Modal */}
        <Modal
          className={`ta-connect-modal right  ${
            this.props.show ? "show" : ""
          }`}
          show={this.props.show}
          onHide={() => this.props.handleModal(false)}
          autoFocus
          keyboard
        >
          <Modal.Header className="modalHeader">
            <h5 onClick={() => this.props.handleModal(false)}>
              <IoArrowBackOutline className="iconArrowLeft" />
              Close
            </h5>
          </Modal.Header>

          <Modal.Body className="modalBody">
            {/* Header Section */}
            <div className="modalBodyHeader">
              <div className="row">
                <div className="col-md-7">
                  <div className="leftContent">
                    <h5 className="modalTitle">Threatcop Admin</h5>
                    <p className="modalSubTitle">
                      Integrate TSAT to Threatcop Admin to enable seamless
                      synchronization.
                    </p>
                    <button
                      className="btn btn-primary"
                      onClick={this.IntegrationHandleShow}
                    >
                      <TfiLink className="mr-2" />
                      Start Integration
                    </button>
                  </div>
                </div>
                <div className="col-md-5 d-flex align-items-center justify-content-end">
                  <div className="rightLogo">
                    <img src={taConnectLogo} alt="TA Connect Logo" />
                  </div>
                </div>
              </div>
            </div>

            {/* Carousel Section */}
            <div className="midModalBody">
              <div className="carouselWrap">
                <Carousel
                  selectedItem={currentSlide}
                  onChange={this.handleSelect}
                  showThumbs={false}
                  showIndicators={false}
                  showStatus={false}
                  centerMode
                  centerSlidePercentage={40.33}
                  renderArrowPrev={(onClickHandler, hasPrev, label) => (
                    <button
                      type="button"
                      onClick={onClickHandler}
                      className="control-arrow control-prev"
                      aria-label={label}
                    >
                      <span className="controlArrow">&#8249;</span>
                    </button>
                  )}
                  renderArrowNext={(onClickHandler, hasNext, label) => (
                    <button
                      type="button"
                      onClick={onClickHandler}
                      className="control-arrow control-next"
                      aria-label={label}
                    >
                      <span className="controlArrow">&#8250;</span>
                    </button>
                  )}
                >
                    {images.map((image, index) => (
            <div
              key={index}
              onClick={() => this.handleOpen(image)}
              className="sliderImg"
              style={{ cursor: "pointer", margin: "10px" }}
            >
              <img
                src={image}
                alt={`Slide ${index + 1}`}
                className="carouselImage"
                onError={(e) => {
                  e.target.src = "fallback-image-url.jpg";
                }}
                style={{ width: "150px", height: "100px", objectFit: "cover" }}
              />
            </div>
          ))}
                </Carousel>
              </div>
            </div>

             {/* Content Section */}
                <div class="contentWrap">
                        <div class="contentInfo">
                            <h4>Why Integration to Threatcop Admin?</h4>
                            <p>Threatcop Admin is our new administrative platform that enables you to centrally manage all your apps, users, groups, and AD integrations from one place. To take advantage of this centralized management, you'll need to integrate your current application to Threatcop Admin.</p>
                        </div>

                        <div class="contentInfo">
                            <h4>About Threatcop Admin?</h4>
                            <p>Threatcop Admin is a unified console that allows administrators to manage all Threatcop applications, users, subscriptions, integrations, and security operations in one place. It streamlines data management, enhances decision-making, and boosts productivity by providing contextually integrated applications under a single platform.</p>
                        </div>

                        <div class="contentInfo">
                            <h4>Key Features & Benefits</h4>
                            <ul class="key-benefits">
                                <li><span class="check"></span>Centralized Management – Control all Threatcop products from a single platform.</li>
                                <li><span class="check"></span>Single Login Access – Securely log in once and manage all Threatcop applications without hassle.</li>
                                <li><span class="check"></span>User & Access Control – Manage users, groups roles, and permissions with ease.</li>
                                <li><span class="check"></span>Seamless Integrations – Connect with third-party applications effortlessly like Azure, G Suite.</li>
                                <li><span class="check"></span>Centralized Analytics – Access all your application analytics in a unified dashboard.</li>
                            </ul>
                        </div>
                    <div class="contentInfo">
                        <h4>Integration Impact</h4>
                        <ul class="integration-impact">
                            <li>
                                <span class="warning"></span>
                                <b>Users and Groups Management:</b><br/>
                                All your users and groups will be synced with Threatcop Admin. Once connected, you can manage them centrally — including adding, deleting, editing, or updating — directly from Threatcop Admin.
                            </li>
                            <li>
                                <span class="warning"></span>
                                <b>SSO Configuration:</b><br/>
                                You will need to reconfigure Single Sign-On (SSO) specifically for the Threatcop Admin panel. Learner SSO remains unaffected.
                            </li>
                            <li>
                                <span class="warning"></span>
                                <b>Domain Management:</b><br/>
                                Your domains will be automatically synced and managed through Threatcop Admin, ensuring consistent domain-level control.
                            </li>
                            <li>
                                <span class="warning"></span>
                                <b>Application Access Routing:</b><br/>
                                Logins to all applications such as TSAT, TLMS, TDMARC, and TPIR will be routed through Threatcop Admin for unified access management.
                            </li>
                            <li>
                                <span class="warning"></span>
                                <b>MFA Setup Required:</b><br/>
                                You will need to re-enable Multi-Factor Authentication (MFA) specifically for Threatcop Admin access.
                            </li>
                            <li>
                                <span class="warning"></span>
                                <b>Domain Type Configuration:</b><br/>
                                You'll be required to set the domain type under the Domains section in Threatcop Admin.
                            </li>
                            <li>
                                <span class="warning"></span>
                                <b>Integration Reconfiguration:</b><br/>
                                Integrations with Microsoft Azure and Google Workspace must be set up again within Threatcop Admin for continued functionality.
                            </li>
                        </ul>
                    </div>
                </div>
          </Modal.Body>
        </Modal>



        {/*Integration Consent Modal */}
        <Modal
          show={showIntegrationModal}
          onHide={this.IntegrationHandleClose}
          className="taConnectIntegModal"
        >
          <Modal.Header closeButton>
            <div>
              <h5>Integration Consent Agreement</h5>
              <p>By proceeding, you agree to the following conditions</p>
            </div>
          </Modal.Header>
          <Modal.Body className="modalBody">
            <ol>
              <li>
                <strong>Users and Groups Management:</strong> All users and groups will be synced with Threatcop Admin and managed centrally, including add, edit, delete, and update actions.
              </li>
              <li>
                <strong>SSO Configuration:</strong> Single Sign-On must be reconfigured for Threatcop Admin. Existing learner SSO will remain unaffected.
              </li>
              <li>
                <strong>Domain Management:</strong> Your domains will be synced and managed via Threatcop Admin for consistent control.
              </li>
              <li>
                <strong>Application Access Routing:</strong> All application logins (TSAT, TLMS, TDMARC, TPIR) will be routed through Threatcop Admin.
                Admin.
              </li>
              <li>
                <strong>MFA Setup Required:</strong> Multi-Factor Authentication must be re-enabled for Threatcop Admin access.
              </li>
              <li>
                <strong>Domain Type Configuration:</strong> You are required to configure domain types under the Domains section in Threatcop Admin.
              </li>
              <li>
                <strong>Integration Reconfiguration:</strong> Existing Microsoft Azure and Google Workspace integrations must be reconfigured in Threatcop Admin.
              </li>
            </ol>

            <Form.Group className="text-center">
              <Form.Check
                type="checkbox"
                id="agreement-checkbox"
                label={
                  <span>
                    By clicking <strong> "I Agree",</strong>, you confirm your understanding and acceptance of the above conditions.
                  </span>
                }
                className="agreement-checkbox"
                checked={agreed}
                onChange={this.handleAgreementChange}
              />
            </Form.Group>

            <div className="modalFooter text-center mt-4 mb-3 ">
              <Button variant="secondary" onClick={this.IntegrationHandleClose} className="mr-2">
                Cancel
              </Button>
              <Button
                variant="success"
                disabled={!agreed}
                onClick={this.handleTAconnection}
              >
                Proceed Integration
              </Button>
            </div>
          </Modal.Body>
        </Modal>




        
      
        {/* Image Preview Modal */}
  
                <Modal show={this.state.show} onHide={this.handleClose} centered size="lg">
                <Modal.Header closeButton>
                    <Modal.Title style={{fontSize:"15px"}}>Preview</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {this.state.selectedImage && (
                    <img
                        src={this.state.selectedImage}
                        alt="Selected Preview"
                        style={{ width: "100%", height: "auto", borderRadius: 8 }}
                    />
                    )}
                </Modal.Body>
                </Modal>

        { this.state.loading? <Loader></Loader>: null }
      </>
    );
  }
}
